import { ShieldAlert, Scale, Info } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/site";
import { Seo } from "@/components/Seo";

export default function DecretoDignita() {
  return (
    <div data-testid="decreto-dignita-page">
      <Seo
        title="Decreto Dignità | TopAffiliation"
        description="Informativa sul Decreto Dignità (D.L. 87/2018) e sull'approccio di TopAffiliation al divieto di pubblicità di giochi e scommesse."
        path="/decreto-dignita"
      />
      <section className="pt-36 md:pt-44 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <span className="eyebrow">Normativa</span>
            <h1 className="mt-5 font-heading text-4xl md:text-5xl font-extrabold">Decreto Dignità</h1>
            <p className="mt-5 text-white/60">
              Informativa sul divieto di pubblicità di giochi e scommesse introdotto dal
              D.L. 87/2018 (c.d. "Decreto Dignità") e sul nostro approccio alla conformità.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: Scale, t: "D.L. 87/2018 — art. 9" },
              { icon: ShieldAlert, t: "Tutela dei minori (18+)" },
              { icon: Info, t: "Gioco responsabile" },
            ].map((b) => (
              <div key={b.t} className="card-surface p-5 flex items-center gap-3">
                <b.icon className="h-5 w-5 text-brand-red shrink-0" />
                <span className="text-sm text-white/70">{b.t}</span>
              </div>
            ))}
          </div>

          <div className="prose-italia mt-10">
            <h2>Cos'è il Decreto Dignità</h2>
            <p>
              Il Decreto Legge 12 luglio 2018, n. 87 (convertito con Legge 96/2018), noto
              come "Decreto Dignità", ha introdotto all'art. 9 il divieto di qualsiasi forma
              di pubblicità, anche indiretta, relativa a giochi o scommesse con vincite in
              denaro, nonché al gioco d'azzardo, con qualsiasi mezzo effettuata.
            </p>

            <h2>Il nostro impegno</h2>
            <p>
              <strong>{SITE.name}</strong> opera nel rispetto della normativa vigente. La
              nostra attività è rivolta a un pubblico <strong>professionale</strong> di
              affiliati, editori e webmaster, e non costituisce promozione al gioco rivolta
              al consumatore finale. I contenuti hanno finalità informativa e di supporto
              all'attività di affiliate marketing.
            </p>
            <ul>
              <li>Accesso e adesione riservati a soggetti maggiorenni (18+).</li>
              <li>Nessun incentivo o invito diretto al gioco rivolto al pubblico generico.</li>
              <li>Promozione del <strong>gioco responsabile</strong> e della piena trasparenza.</li>
              <li>Collaborazione esclusivamente con operatori regolarmente autorizzati.</li>
            </ul>

            <h2>Gioco responsabile</h2>
            <p>
              Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica.
              Invitiamo tutti gli utenti a informarsi sui rischi e a rivolgersi ai numeri
              verdi e ai servizi dedicati in caso di necessità.
            </p>

            <h2>Contatti</h2>
            <p>
              Per informazioni relative alla presente informativa è possibile scrivere a{" "}
              <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
